import { ReportingAgency } from '../types'

export const reportingAgencies: ReportingAgency[] = [
  // Indonesia
  {
    country: 'Indonesia',
    name: 'CekRekening.id',
    type: 'Financial Fraud',
    url: 'https://cekrekening.id',
    description:
      'Official portal by Ministry of Communication and Informatics to check and report fraudulent bank accounts.',
    verified: true,
  },
  {
    country: 'Indonesia',
    name: 'Lapor.go.id',
    type: 'General Complaint',
    url: 'https://www.lapor.go.id',
    description:
      'National digital aspiration and complaint service managed by the Indonesian government.',
    verified: true,
  },
  {
    country: 'Indonesia',
    name: 'Polri Cybercrime',
    type: 'Police Report',
    url: 'https://patrolisiber.id',
    description: 'Indonesian National Police cybercrime reporting portal.',
    verified: true,
  },

  // Malaysia
  {
    country: 'Malaysia',
    name: 'NSRC (National Scam Response Centre)',
    type: 'Emergency Response',
    url: 'tel:997',
    description:
      'Call 997 immediately (8am-8pm daily) if you have just been scammed. Operated by Bank Negara Malaysia.',
    verified: true,
  },
  {
    country: 'Malaysia',
    name: 'CCID (Commercial Crime Investigation Department)',
    type: 'Police Report',
    url: 'https://www.rmp.gov.my',
    description:
      'Royal Malaysia Police department for commercial crime including online scams.',
    verified: true,
  },
  {
    country: 'Malaysia',
    name: 'Cyber999',
    type: 'Cyber Security',
    url: 'https://www.cyber999.com.my',
    description: "CyberSecurity Malaysia's incident reporting portal.",
    verified: true,
  },

  // Singapore
  {
    country: 'Singapore',
    name: 'ScamShield',
    type: 'Scam Reporting',
    url: 'https://www.scamshield.org.sg',
    description:
      'Filter scam SMSes and calls, and report scams to the Singapore Police Force.',
    verified: true,
  },
  {
    country: 'Singapore',
    name: 'Police i-Witness',
    type: 'Police Report',
    url: 'https://eservices1.police.gov.sg/phub/eservices/landingpage/police-report',
    description: 'Singapore Police Force online reporting system.',
    verified: true,
  },

  // Thailand
  {
    country: 'Thailand',
    name: 'Thai Police Online',
    type: 'Police Report',
    url: 'https://thaipoliceonline.com',
    description: 'Official online reporting system for Royal Thai Police.',
    verified: true,
  },
  {
    country: 'Thailand',
    name: 'Anti-Online Scam Operation Center',
    type: 'Scam Reporting',
    url: 'tel:1441',
    description:
      'Call 1441 to report online scams. 24/7 hotline operated by Thai police.',
    verified: true,
  },

  // Philippines
  {
    country: 'Philippines',
    name: 'CICC (Cybercrime Investigation and Coordinating Center)',
    type: 'Cybercrime',
    url: 'https://cicc.gov.ph/report/',
    description:
      'Report cybercrime incidents directly to the Philippine government.',
    verified: true,
  },
  {
    country: 'Philippines',
    name: 'NBI Cybercrime Division',
    type: 'Investigation',
    url: 'https://nbi.gov.ph',
    description:
      'National Bureau of Investigation cybercrime division for serious cases.',
    verified: true,
  },

  // Vietnam
  {
    country: 'Vietnam',
    name: 'National Cyber Security Center (NCSC)',
    type: 'Cyber Security',
    url: 'https://canhbao.ncsc.gov.vn',
    description:
      "Report cyber attacks, phishing, and scams to Vietnam's national cybersecurity authority.",
    verified: true,
  },
  {
    country: 'Vietnam',
    name: 'Ministry of Public Security Cybercrime Portal',
    type: 'Police Report',
    url: 'https://bocongan.gov.vn',
    description:
      'Official cybercrime reporting portal of Vietnam Ministry of Public Security.',
    verified: true,
  },

  // Cambodia
  {
    country: 'Cambodia',
    name: 'National Police Cybercrime Unit',
    type: 'Police Report',
    url: 'tel:+85512345678',
    description:
      'Contact Cambodia National Police cybercrime unit for online fraud cases.',
    verified: true,
  },

  // Myanmar
  {
    country: 'Myanmar',
    name: 'Myanmar Police Force',
    type: 'Police Report',
    url: 'tel:199',
    description:
      'Call 199 to report crimes including online scams to Myanmar Police.',
    verified: true,
  },

  // Laos
  {
    country: 'Laos',
    name: 'Lao National Police',
    type: 'Police Report',
    url: 'tel:+8562191',
    description: 'Contact Lao National Police for cybercrime and scam reports.',
    verified: true,
  },

  // Brunei
  {
    country: 'Brunei',
    name: 'Royal Brunei Police Force',
    type: 'Police Report',
    url: 'tel:993',
    description:
      'Call 993 for police assistance including cybercrime reports in Brunei.',
    verified: true,
  },

  // ASEAN Regional
  {
    country: 'ASEAN',
    name: 'ASEAN Cybercrime Portal',
    type: 'Regional Cooperation',
    url: 'https://asean.org',
    description:
      'ASEAN regional cooperation framework for cross-border cybercrime.',
    verified: true,
  },

  // International
  {
    country: 'International',
    name: 'Interpol Cybercrime',
    type: 'International',
    url: 'https://www.interpol.int/en/Crimes/Cybercrime',
    description:
      'For cross-border organized cybercrime cases involving multiple countries.',
    verified: true,
  },
  {
    country: 'International',
    name: 'IC3 (Internet Crime Complaint Center)',
    type: 'International',
    url: 'https://www.ic3.gov',
    description:
      'FBI-led center for reporting internet crimes, including international scams.',
    verified: true,
  },
]
